import { reactive, onUnmounted, onMounted } from '@nuxtjs/composition-api';

interface UseScrollOptions {
  onScroll?: (x: number, y: number) => void;
}

/**
 * スクロール座標を提供する関数
 */
export function useScroll(options: UseScrollOptions = {}) {
  const scroll = reactive({
    x: 0,
    y: 0,
  });

  const update = (event: Event) => {
    // scroll.x = window.scrollX;
    // scroll.y = window.scrollY;

    // TODO: レイアウトで overflow: hidden; を入れたことによって window オブジェクトが
    //       スクロールしなくなるので、ターゲットオブエジェクトから x, y を割り出すようにしている。
    //       しかし、これで本当に良いかどうかまだ疑問が残るので要調査
    // @ts-ignore
    scroll.x = event?.target?.scrollLeft ?? 0;
    // @ts-ignore
    scroll.y = event?.target?.scrollTop ?? 0;

    if (options?.onScroll) {
      options?.onScroll(scroll.x, scroll.y);
    }
  };

  onMounted(() => {
    scroll.x = window.scrollX;
    scroll.y = window.scrollY;
    window.addEventListener('scroll', update, {
      capture: true,
      // once: false,
      // passive: true,
    });
  });

  onUnmounted(() => {
    window.removeEventListener('scroll', update, {
      capture: true,
    });
  });

  return scroll;
}
